/**
 * Read more/less button
 * 
 * The initial height can be set in any CSS unit
 * 
 * DATA-OPTIONS
 * initialHeight  @String
 * readMoreText   @String
 * readLessText   @String
 * 
 * HTML Usage:
    <read-more class="read-more" data-read-more-group data-options='{}'>
      <div data-read-more-target class="read-more__content element-spacing">
      {{ content }}
      </div>
      <button type="button" class="read-more__trigger button" data-read-more-trigger>
        <span data-read-more-trigger-label>{{ label }}</span>
        {%- render 'global-icon', icon: 'arrow-down', icon_size: "xs" icon_class: "read-more__trigger-icon" -%}
      </button>
    </read-more>
 */

class ReadMore extends HTMLElement {
  constructor() {
    super();

    // Get elements
    this.group = this.hasAttribute('data-read-more-group') ? this : this.querySelector('[data-read-more-group]');
    this.target = this.querySelector('[data-read-more-target]');
    this.targetScrollHeight = this.target.scrollHeight;
    this.trigger = this.querySelector('[data-read-more-trigger]');
    this.triggerLabel = this.querySelector('[data-read-more-trigger-label]');

    // Options
    this.options = {
      initialHeight: '25vh',
      readMoreText: 'Read more',
      readLessText: 'Read less',
    }

    // Get options from element data and combine with this.options
    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions,
      };
    }

    // Init
    this.init();

    // Event listeners
    this.trigger.addEventListener('click', () => this.target.style.maxHeight === this.options.initialHeight ? this.expandHeight() : this.shrinkHeight());
    window.addEventListener('resize', this.updateHeight.bind(this));
    
  }

  init() {
    this.target.style.maxHeight = this.options.initialHeight
    this.triggerLabel.innerHTML = this.options.readMoreText;
  }

  expandHeight() {
    this.target.style.maxHeight = `${this.targetScrollHeight}px`
    this.triggerLabel.innerHTML = this.options.readLessText;
    this.group.classList.add('read-more--expanded');
  }

  shrinkHeight() {
    this.target.style.maxHeight = this.options.initialHeight;
    this.triggerLabel.innerHTML = this.options.readMoreText;
    this.group.classList.remove('read-more--expanded');
  }

  updateHeight() {
    this.targetScrollHeight = this.target.scrollHeight;
    
    if (this.target.style.maxHeight != this.options.initialHeight) {
      this.target.style.maxHeight = `${this.targetScrollHeight}px`;
    }
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
